module.exports = __webpack_public_path__ + "static/js/dataToCsv.e2ae4c3b.chunk.worker.js"